// eslint-disable-next-line no-restricted-imports
import React from 'react';
import dynamic from 'next/dynamic';

const ErrorDisplay = dynamic(() => import('./ErrorDisplay'));

type ErrorBoundaryProps = {
  children: JSX.Element;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    const { recordError } = await import('../../analytics/uiMetrics');
    recordError(error, info.componentStack);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorDisplay />;
    }

    return children;
  }
}

export default ErrorBoundary;
